<template>
  <div>
    <label class="block text-xs font-medium text-gray-700 mb-1" :for="fieldId">
      {{ label }}
    </label>
    <div class="relative">
      <input
        :id="fieldId"
        type="text"
        v-model="searchValue"
        @input="handleInput"
        @keydown.escape="clearSearch"
        :placeholder="placeholder"
        class="block w-full bg-gray-200 border border-gray-400 rounded-lg pl-3 pr-8 py-2 text-left sm:text-sm focus:outline-none focus:border-gray-400 focus:ring-0 placeholder-gray-500"
      />
      
      <!-- Clear button -->
      <button
        v-if="searchValue"
        @click="clearSearch"
        type="button"
        class="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
      >
        <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
import _ from "lodash";

export default {
  props: {
    label: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      default: ''
    },
    modelValue: {
      type: String,
      default: ''
    },
    debounce: {
      type: Number,
      default: 750
    }
  },
  
  data() {
    return {
      searchValue: this.modelValue
    };
  },
  
  computed: {
    fieldId() {
      // Generate a unique ID based on the label
      return 'search_' + this.label.toLowerCase().replace(/\s+/g, '_');
    }
  },
  
  watch: {
    modelValue(newValue) {
      this.searchValue = newValue;
    }
  },
  
  methods: {
    handleInput: _.debounce(function() {
      this.$emit('update:modelValue', this.searchValue);
      this.$emit('search', this.searchValue);
    }, function() { return this.debounce; }),
    
    clearSearch() {
      this.searchValue = '';
      this.$emit('update:modelValue', '');
      this.$emit('search', '');
    }
  }
};
</script>